module.exports = __webpack_public_path__ + "img/coco.a54fa9d9.png";